import React, { useEffect, useState } from 'react';
import { Button, MessageBlock } from '../../../ui';

export const CONTRACT_LOAD_STATUS = {
  IDLE: 'idle',
  LOADING: 'loading',
  AVAILABLE: 'available',
  UNAVAILABLE: 'unavailable'
};

const ContractAvailabilityAlert = ({
  contractLoadStatus = CONTRACT_LOAD_STATUS.IDLE,
  contractLoadError = '',
  contractDownloadError = '',
  isDownloadingContract = false,
  onRetryLoad,
  onRetryDownload,
  onViewContract
}) => {
  const [showTechnicalDetails, setShowTechnicalDetails] = useState(false);

  useEffect(() => {
    setShowTechnicalDetails(false);
  }, [contractLoadStatus, contractLoadError]);

  if (contractLoadStatus === CONTRACT_LOAD_STATUS.LOADING) {
    return (
      <MessageBlock tone="info" title="Cargando contrato" className="mb-4" role="status">
        Estamos preparando el contrato para consulta y firma.
      </MessageBlock>
    );
  }

  if (contractLoadStatus === CONTRACT_LOAD_STATUS.UNAVAILABLE) {
    const hasTechnicalDetails = Boolean(contractLoadError);

    return (
      <MessageBlock
        tone="error"
        title="No pudimos cargar el contrato"
        className="mb-4"
        actions={(
          <>
            <Button
              variant="outlinePrimary"
              size="sm"
              onClick={onRetryLoad}
              disabled={contractLoadStatus === CONTRACT_LOAD_STATUS.LOADING}
            >
              Reintentar
            </Button>
            {hasTechnicalDetails && (
              <Button
                variant="link"
                size="sm"
                onClick={() => setShowTechnicalDetails((current) => !current)}
                aria-expanded={showTechnicalDetails}
              >
                {showTechnicalDetails ? 'Ocultar detalles' : 'Ver detalles'}
              </Button>
            )}
          </>
        )}
      >
        La firma no puede iniciarse hasta que el contrato esté disponible.
        {showTechnicalDetails && hasTechnicalDetails && (
          <span className="d-block mt-2 text-muted small">{contractLoadError}</span>
        )}
      </MessageBlock>
    );
  }

  if (contractDownloadError && contractLoadStatus === CONTRACT_LOAD_STATUS.AVAILABLE) {
    return (
      <MessageBlock
        tone="warning"
        title="La descarga automática no se completó"
        className="mb-4"
        actions={(
          <>
            <Button variant="outlinePrimary" size="sm" onClick={onViewContract}>
              Ver contrato
            </Button>
            <Button
              variant="outlinePrimary"
              size="sm"
              onClick={onRetryDownload}
              disabled={isDownloadingContract}
            >
              Reintentar descarga
            </Button>
          </>
        )}
      >
        El contrato está disponible para consultar en línea. Podés volver a descargarlo.
      </MessageBlock>
    );
  }

  return null;
};

export default ContractAvailabilityAlert;
